module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Da-Ea.325fd653.png";